/**
 * «Oppsett» on Oversikt (PM gaps B4, 2026-11-01): what is still missing for the mosque to use what it has — no own
 * privacy page, functions waiting for the page to be approved, Vipps not set up, functions switched on that wait for
 * another or for keys from Min Masjid. Each line leads to the page where it is fixed (only a page this person may open).
 * For the admin tier (settings.write) only, from two endpoints the panel already reads with their own permissions:
 * GET /capabilities (settings.write) and GET /privacy-page (privacy.manage). Absent when nothing is missing.
 */
import React from 'react';
import { can, type Body } from '../lib/api';
import { useLoad } from '../lib/hooks';
import { useNav } from '../lib/nav';
import { setupLines } from '../lib/features';
import { Shell } from '../core';

export function SetupCard() {
  const { go, caps } = useNav();
  const admin = can('settings.write');
  const features = useLoad<Body>(admin ? '/capabilities' : null);
  const privacy = useLoad<Body>(admin && can('privacy.manage') ? '/privacy-page' : null);
  if (!admin) return null;
  const lines = setupLines(features.data ? features.data.items || [] : null, privacy.data);
  if (!lines.length) return null;
  const labelOf = (id: string) => (Shell.NAV.find((n) => n.id === id) || { label_no: id }).label_no;
  const mayOpen = (id: string) => { const item = Shell.NAV.find((n) => n.id === id); return Boolean(item && Shell.permits(item, can) && Shell.capabilityAllows(item, caps)); };
  return (
    <section aria-labelledby="setup-h" className="att-wrap">
      <h2 id="setup-h" className="ov-h">Oppsett</h2>
      <ul className="att-list">{lines.map((l) => (
        <li key={l.key} className="att info">
          <div className="att-text"><b>{l.title}</b><span>{l.why}</span></div>
          {mayOpen(l.to) && <button type="button" className="btn sm att-go" onClick={() => go(l.to)}>Gå til {labelOf(l.to)}</button>}
        </li>))}
      </ul>
    </section>
  );
}
